<template>
	<div>
		<div class="position-relative z-index-1040">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-table w-100 nav-top py-3 bg-green">
          <div class="custom-container-fluid px-0" :class="{'py-2':getMerchant.booking_engine_header_title_type == 'TEXT'}">
            <div class="px-5">
              <div class="px-3">
                <div class="row no-gutters">
                  <div class="col-6 align-self-center">
                    <!-- <p  
                    	v-if="page == 'search'"
                      @click="openCurLang" 
                      class="mb-0 body-2-2 text-white cursor-pointer">
                      <span>{{$t('hotel.language')}}</span> | {{getCurrency.name}} ({{getCurrency.code}}) 
                      <i class="simple-icon-arrow-down"></i>
                    </p>
                    <template v-if="page == 'cart'">
                    </template> -->
										<div class="d-table cursor-pointer" @click="backClicked()">
											<p class="mb-0 heading-6 font-bold text-white w-100" v-if="getMerchant.booking_engine_header_title_type == 'TEXT'">{{getMerchant.name}}</p>
											<img v-if="getMerchant.booking_engine_header_title_type == 'IMAGE'" :src="getMerchant.image_url" class="d-table" style="height:46px;">
										</div>
                  </div>

									<!-- NOT USED -->
                  <div class="col-6 align-self-center" v-if="false">
                  	<template v-if="page == 'search'">
	                    <p class="mb-0 heading-6 font-bold text-white w-100 text-center" v-if="getMerchant.booking_engine_header_title_type == 'TEXT'">{{getMerchant.name}}</p>
	                    <img v-if="getMerchant.booking_engine_header_title_type == 'IMAGE'" :src="getMerchant.image_url" class="mx-auto d-table" style="height:46px;">
                    </template>
                    <div class="text-center" v-if="page == 'cart'">
                    	<div class="bg-light-desktop d-inline-block rounded-100 w-30px text-center">
					    					<p class="mb-0 font-bold body-2-2 pt-1" :class="{'text-green':cart_step == 1}">1</p>
					    				</div>
					    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block text-white">{{$t('hotel.order')}}</p>
					    				<div class="rounded-4 d-inline-block position-relative" style="border-top: 3px dashed #eee;width: 44px;top: -2px;"></div>

					    				<div class="bg-light-desktop d-inline-block rounded-100 w-30px text-center" :class="{'bg-green':cart_step == 2}">
					    					<p class="mb-0 font-bold body-2-2 pt-1" :class="{'text-green':cart_step == 2}">2</p>
					    				</div>
					    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block text-white">{{$t('hotel.payment')}}</p>
					    				<div class="rounded-4 d-inline-block position-relative" style="border-top: 3px dashed #eee;width: 44px;top: -2px;"></div>
					    				
					    				<template v-if="cart_step == 'waiting' || cart_step == 'being_processed' || cart_step == 'w_confirm'">
						    				<div class="bg-light-desktop d-inline-block rounded-100 w-30px text-center">
						    					<p class="mb-0 font-bold body-2-2 pt-1" :class="{'text-green':cart_step == 'waiting' || cart_step == 'being_processed' || cart_step == 'w_confirm'}">3</p>
						    				</div>
						    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block text-white" v-if="cart_step == 'waiting'">{{$t('hotel.waiting.waiting-payment')}}</p>
						    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block text-white" v-if="cart_step == 'w_confirm'">Waiting Confirmation</p>
						    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block text-white" v-if="cart_step == 'being_processed'">{{$t('hotel.waiting.being-processed')}}</p>

						    				<div class="rounded-4 d-inline-block position-relative" style="border-top: 3px dashed #eee;width: 44px;top: -2px;"></div>
					    				</template>

					    				<div class="bg-light-desktop d-inline-block rounded-100 w-30px text-center">
					    					<p class="mb-0 font-bold body-2-2 pt-1" :class="{'text-green':cart_step == 3}">
					    						<span v-if="cart_step == 1 || cart_step == 2 || cart_step == 3">3</span>
					    						<span v-if="cart_step == 'failed'">3</span>
					    						<span v-if="cart_step == 'waiting' || cart_step == 'being_processed' || cart_step == 'w_confirm'">4</span>
					    					</p>
					    				</div>
					    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block text-white" v-if="cart_step == 1 || cart_step == 2 || cart_step == 3 || cart_step == 'waiting' || cart_step == 'being_processed' || cart_step == 'w_confirm'">{{$t('hotel.complete')}}</p> 
					    				<p class="mb-0 mt-1 body-2-2 font-semibold d-inline-block text-white" v-if="cart_step == 'failed'">{{$t('hotel.failed.reservation-failed')}}</p>
                    </div>
                  </div>


                  <div v-if="getMerchant.use_user_menu" class="col-6 text-right align-self-center">
                    <router-link :to="'/'+getMerchant.code+'/account'">
                      <div class="w-100 no-ws" @click="setActiveRoute('booking')">
                        <template v-if="!isNotLogin">
                          <img style="padding: 2px"
                            :src="getCurrentUser.avatar" 
                            width="30" 
                            height="30" 
                            class="rounded-100 border-2-green object-fit d-inline-block align-middle mr-2">
                            <p class="body-2-2 text-white d-inline-block align-middle mb-0">{{getCurrentUser.first_name}}</p>
                        </template> 
                        <p v-else class="body-2-2 text-white d-table ml-auto rounded-4 lh-1 mb-0" style="border:2px solid #fff;padding:6px 10px;">{{$t('profile.login.login')}}</p>
                      </div>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="w-100 d-block" style="height:78px;"></div>
	</div>
</template>
<script>
	import {mapGetters,mapMutations} from 'vuex'
	export default{
		props:{
			page:{
				type: String,
				default: 'search'
			},
			cart_step:{
				type: Number,
				default: 1
			}	
		},
		computed:{
			...mapGetters(['getMerchant','getCurrency','isNotLogin','getCurrentUser'])
		},
		methods:{
			...mapMutations(['setActiveRoute']),
			openCurLang(){
				this.$emit('openCurLang', true)
			},
			backClicked(){
				this.$emit('backClicked')
			}
		}
	}
</script>
<style scoped>
	
	@media screen and (max-width: 992px) {
		.px-5{
			padding-left: 0!important;
			padding-right: 0!important;
		}
	}

	@media screen and (max-width: 1200px) {
		.px-5{
			padding-left: 0.5rem!important;
			padding-right: 0.5rem!important;
		}
	}

</style>


// WEBPACK FOOTER //
// src/components/hotel/be/desktop/navbar.vue